import { DisponibleCuenta } from "./DisponibleCuenta";

export class CentroCostoLista {
  id: number;
  denominacion: string;
  codigo: string;
  detalle: string;
  centroCostoId: number;
  numeroCuenta: string;
  disponible: DisponibleCuenta;
  fechaObtenido: Date;
  hijos: CentroCostoLista[] = [];
  message: string;
  status: string;

  constructor(data: any) {
    for(const key in data) {
      if (key === 'hijos') {
        this[key] = data[key].map((cc) => new CentroCostoLista(cc));
      } else {
        this[key] = data[key];
      }
    }
  }

  get formattedName() {
    return `${this.denominacion} (${this.codigo}) / ${this.numeroCuenta}`;
  }
}
